<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
     <v-overlay :value="!dataReady">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
         <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                dense
                outlined
                hide-details
                label="แผนก"
                class="ma-2"
              ></v-select>
                <v-icon
                color="#871B12"
                size="30"
                @click="getData()"
                >mdi-calendar-search</v-icon
              >
              <v-icon
                color="#871B12"
                size="30"
                @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
         <!-- data table -->
         <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                <template v-slot:[`item.empImageUrl`]="{ item }">
                        <v-avatar
                             size="72"
                          >
                            <img
                              v-if="item.empImageUrl"
                              alt="Avatar"
                              :src="item.empImageUrl"
                            >
                          </v-avatar>
                      </template>
                   <template v-slot:[`item.CREATE_DATE`]="{ item }">
                      {{ format_date(item.CREATE_DATE) }}
                  </template>
                   <template v-slot:[`item.LAST_DATE`]="{ item }">
                      {{ format_date(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      v-if="!item.positionCode"
                      color="red darken-1"
                      dark
                      fab
                      small
                      @click="deleteData(item)"
                    >
                      <v-icon dark> mdi-close-circle </v-icon>
                    </v-btn>
                    <v-btn
                      color="#1A237E"
                      dark
                      fab
                      small
                      @click="viewEmp(item)"
                    >
                      <v-icon dark> mdi-eye-outline </v-icon>
                    </v-btn>
                    <v-btn
                      color="#2E7D32"
                      dark
                      fab
                      small
                      @click="exportEmp(item)"
                    >
                      <v-icon dark> mdi-file-import </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import titleNameTH from '../../../assets/master/titleName/titleNameTH.json'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      e1: 1,
      PK: '',
      path: '/employee/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ข้อมูลพนักงานสาขา',
          disabled: true,
          href: '/HRM/Employee/EmployeeManageGA'
        }
      ],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'EMP', // Generate Code
      // Dialog ADD IMPORT
      dialogAdd: false,
      dialogImport: false,
      panel1: '',
      session: this.$session.getAll(),
      searchAll2: '',
      // Search Advanced
      search: {
        empCode: '',
        empFull_NameTH: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },

      // form Info //
      formAdd: {
        empCode: '',
        empId: '',
        empTitle_NameTH: '',
        empFirst_NameTH: '',
        empLast_NameTH: ''
      },

      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => (v && v.length <= 50) || 'Name must be less than 50 characters'
      ],
      // Data Table Config
      columns: [
        { text: 'รหัสพนักงาน', value: 'empCode', align: 'center' },
        { text: 'ชื่อ-นามสกุล', value: 'empFull_NameTH' },
        { text: 'อัตรากำลัง', value: 'positionName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      // End Data Table Config

      // Config Import
      columnsImport: [
        { text: 'empId', value: 'empId' },
        { text: 'empCode', value: 'empCode' },
        { text: 'positionCode', value: 'positionCode' },
        { text: 'empTitle_NameTH', value: 'empTitle_NameTH' },
        { text: 'empFirst_NameTH', value: 'empFirst_NameTH' },
        { text: 'empLast_NameTH', value: 'empLast_NameTH' },
        { text: 'empTitle_NameEN', value: 'empTitle_NameEN' },
        { text: 'empFirst_NameEN', value: 'empFirst_NameEN' },
        { text: 'empLast_NameEN', value: 'empLast_NameEN' },
        { text: 'empNickname', value: 'empNickname' },
        { text: 'empBirthday', value: 'empBirthday' },
        { text: 'empGender', value: 'empGender' },
        { text: 'empIDCard', value: 'empIDCard' },
        { text: 'empEmail', value: 'empEmail' },
        { text: 'empTel', value: 'empTel' },
        { text: 'empEmergencyCall', value: 'empEmergencyCall' },
        { text: 'empFacebook', value: 'empFacebook' },
        { text: 'empLineID', value: 'empLineID' },
        { text: 'empDriverLicense', value: 'empDriverLicense' },
        { text: 'empDriverLicenseType', value: 'empDriverLicenseType' }
      ],
      dataItemImportChecKHide: true,
      dataItemImport: [],
      // End Config Import
      // Export Config
      exportType: 'xls',
      exportFileName: 'HRM-Employee-EmployeeManage.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        empId: 'empId',
        empCode: 'empCode',
        positionCode: 'positionCode',
        empTitle_NameTH: 'empTitle_NameTH',
        empFirst_NameTH: 'empFirst_NameTH',
        empLast_NameTH: 'empLast_NameTH',
        empTitle_NameEN: 'empTitle_NameEN',
        empFirst_NameEN: 'empFirst_NameEN',
        empLast_NameEN: 'empLast_NameEN',
        empNickname: 'empNickname',
        empBirthday: 'empBirthday',
        empGender: 'empGender',
        empIDCard: 'empIDCard',
        empEmail: 'empEmail',
        empTel: 'empTel',
        empEmergencyCall: 'empEmergencyCall',
        empFacebook: 'empFacebook',
        empLineID: 'empLineID',
        empDriverLicense: 'empDriverLicense',
        empDriverLicenseType: 'empDriverLicenseType'
      },
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      titleNameTH: titleNameTH,
      empCode: '',
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      disableBranch: true,
      disableDeparment: true
    }
  },
  async mounted () {
    localStorage.removeItem('dataByHR')
    await this.getGetTokenForEmployee()
    this.dataReady = false
    await this.getDataDepartment()

    // Get Data
    await this.getData()
    // this.getDataTitleTH()
  },
  methods: {
    async clear () {
      console.log('clear')
      this.Department = ''
      await this.getData()
    },
    async getData () {
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import

      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "get?masBranchName=" + this.$session.getAll().data.masBranchName + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
          this.dataItem.forEach((data) => {
            if (data.empImageUrl) {
              data.empImageUrl = this.DNS_IP + '/' + data.empImageUrl
            }
          })
          console.log(this.dataItem)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    async getDataTitleTH () {
      this.titleNameTH = []
      if (localStorage.getItem('titleNameTH')) {
        this.titleNameTH = JSON.parse(localStorage.getItem('titleNameTH'))
      } else {
        await axios
          .get(
          // eslint-disable-next-line quotes
            this.DNS_IP + "/master_title/" + "get",
            {
              headers: {
                'Application-Key': localStorage.getItem('ApplicationKey')
              }
            }

          )
          .then(async (response) => {
            let rs = response.data
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.value = d.titleNameTH
              s.text = d.titleNameTH
              d = s
              this.titleNameTH.push(d)
              localStorage.titleNameTH = JSON.stringify(this.titleNameTH)
            }
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log(error)
          })
      }
    },
    async addData () {
      var data = JSON.parse(localStorage.getItem('data'))
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = data.userName
      this.formAdd.LAST_USER = data.userName
      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
      //
      // กำหนด Code ของรายการ * อย่าลืมเปลี่ยน field
      //
      this.getRunningCodeGlobal(this.DNS_IP, 'EMP').then(async (response) => {
        this.formAdd.empCode = response
        console.log(this.formAdd)
        this.dataReady = false
        this.submitAdd()
      })
    },
    async submitAdd () {
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          delete this.formAdd['empId']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              this.formAdd,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }

            )
            .then(async (response) => {
              // Debug response
              console.log('addDataGlobal DNS_IP + "/employee/" + "add"', response)

              if (response.status === 200) {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                this.dialogAdd = false
                this.dataReady = true
                this.clearData()
                await this.getDataGlobal(this.DNS_IP, this.path)
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        if (this.formAdd[key]) {
          this.formAdd[key] = ''
        }
      }
    },
    async viewEmp (dt) {
      localStorage.setItem('CanEdit', false)
      localStorage.setItem('roll', 'GA')
      localStorage.setItem('Page', '/HRM/Employee/EmployeeManageGA')
      localStorage.setItem('dataByHR', JSON.stringify(dt))
      this.$router.push(
        '/HRM/Employee/EmployeeInfo'
      )
    },
    async exportEmp (dt) {
      console.log(dt)
      var teminfo = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee/getEmpCode?empCode=" + dt.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          response.data.forEach(element => {
            let s = {
              'รหัสพนักงาน': element.empCode,
              'รหัสพนักงานเก่า': element.empCodeOld,
              'รหัสตำแหน่ง': element.positionCode,
              'คำนำหน้าชื่อไทย': element.empTitle_NameTH,
              'ขื่อไทย': element.empFirst_NameTH,
              'นามสกุลไทย': element.empLast_NameTH,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'คำนำหน้าชื่ออังกฤษ': element.empTitle_NameEN,
              'ชื่อภาษาอังกฤษ': element.empFirst_NameEN,
              'นามสกุลอังกฤษ': element.empLast_NameEN,
              'ชื่อ-นามสกุลอังกฤษ': element.empFull_NameEN,
              'ชื่อเล่น': element.empNickname,
              'วันเกิด': element.empBirthday,
              'อายุ': element.AGE,
              'เพศ': element.empGender,
              'เบอร์ติดต่อ': element.empTel,
              'รหัสบัตรประชาชน': element.empIDCard,
              'Facebook': element.empFacebook,
              'LINE ID': element.empLineID,
              'เบอร์ฉุกเฉิน': element.empEmergencyCall,
              'เลขใบขับขี่': element.empDriverLicense,
              'ประเภทใบขับขี่': element.empDriverLicenseType,
              'งานอดิเรก': element.hobby,
              'วันทำบัตรประชาชน': element.issuedDate,
              'วันหมดอายุบัตรประชาชน': element.expireDate,
              'สถานที่ทำบัตรประชาชน': element.issuedAt,
              'จังหวัดที่ทำบัตรประชาชน': element.issuedProvince,
              'รับรองทางทหาร': element.masMilitaryStatusCode,
              'ตำแหน่งงาน': element.positionName,
              'ประเภทตำแหน่งงาน': element.positionTypeName,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'ความสามารถพิเศษอื่นๆ': element.empGenius,
              'วันที่เริ่มทำงาน': element.startDate,
              'อายุงาน': element.workDate
            }
            teminfo.push(s)
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      var info = XLSX.utils.json_to_sheet(teminfo)
      var wb = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(wb, info, 'info')

      var temfamily = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_family/getEmpCode?empCode=" + dt.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          response.data.forEach(element => {
            // var s = {}
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'ความสัมพันธ์': element.familyStatus,
              'คำนำหน้า': element.familyTitleName,
              'ชื่อ': element.familyFirstName,
              'นามสกุล': element.familyLastName,
              'อาชีพ': element.familyCareer,
              'ที่อยู่/สถานที่ทำงาน': element.familyAddress,
              'เบอร์โทรศัพท์': element.familyTel,
              'เป็นผู้ติดต่อกรณีฉุกเฉิน': element.emergencyStatus,
              'อยู่กับครอบครัว': element.familyStayWithFamStatus
            }
            temfamily.push(s)
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      var family = XLSX.utils.json_to_sheet(temfamily)
      XLSX.utils.book_append_sheet(wb, family, 'family')

      var temaddress = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_address/getEmpCode?empCode=" + dt.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          response.data.forEach(element => {
            // var s = {}
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'ที่อยู่': element.empAddressName,
              'รหัสไปรษณี': element.empAddressZipcode,
              'จังหวัด': element.empAddressProvine,
              'อำเภอ': element.empAddressDistrict,
              'ตำบล': element.empAddressSubDistrict,
              'ประเภทที่อยู่': element.empAddressStatus
            }
            temaddress.push(s)
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      var address = XLSX.utils.json_to_sheet(temaddress)
      XLSX.utils.book_append_sheet(wb, address, 'address')

      var tempComputerSkill = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_computer_skill/getEmpCode?empCode=" + dt.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          response.data.forEach(element => {
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'ทักษะคอมพิวเตอร์': element.masComputerSkillCode,
              'คะแนนความสามารถ': element.empComputerSkillScore,
              'ใบเซอร์': element.empComputerSkillCers
            }
            tempComputerSkill.push(s)
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      var ComputerSkill = XLSX.utils.json_to_sheet(tempComputerSkill)
      XLSX.utils.book_append_sheet(wb, ComputerSkill, 'ComputerSkill')

      var tempLanguageSkill = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_language_skill/getEmpCode?empCode=" + dt.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          response.data.forEach(element => {
            // var s = {}
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'ทักษะภาษา': element.languageCode,
              'การอ่าน': element.empLanguageRead,
              'การพูด': element.empLanguageSpeak,
              'การเขียน': element.empLanguageWrite
            }
            tempLanguageSkill.push(s)
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      var LanguageSkill = XLSX.utils.json_to_sheet(tempLanguageSkill)
      XLSX.utils.book_append_sheet(wb, LanguageSkill, 'LanguageSkill')

      var tempEducation = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_education/getEmpCode?empCode=" + dt.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          response.data.forEach(element => {
            // var s = {}
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'ระดับการศึกษา': element.educationLevel,
              'จบการศึกษา': element.educationYear,
              'เกรด': element.educationGrade,
              'สาขาเรียน': element.educationDepartment,
              'คณะ': element.educationFaculty,
              'สถาบัน': element.educationName,
              'สถานะการศึกษา': element.educationStatus,
              'ประเภทสถาบัน': element.educationAcademyGroup
            }
            tempEducation.push(s)
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      var Education = XLSX.utils.json_to_sheet(tempEducation)
      XLSX.utils.book_append_sheet(wb, Education, 'Education')

      var tempHealth = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee_health/getEmpCode?empCode=" + dt.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          response.data.forEach(element => {
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'อีเมล': element.empEmail,
              'เพศ': element.empGender,
              'เบอร์ติดต่อ': element.empTel,
              'รหัสบัตรประชาชน': element.empIDCard,
              'บริษัท ประกัน': element.empHealthName,
              'กรมธรรม์เลขที่': element.healthGroupNumber,
              'วันที่ แจ้งเข้า': element.healthGroupStartDate,
              'เข้าระบบ / ต่ออายุ': element.healthGroupRenew,
              'วันที่ เริ่มคุ้มครอง': element.healthGroupStart,
              'วันที่ สิ้นสุด คุ้มครอง': element.healthGroupEnd,
              'สถานพยาบาล': element.healthAddress,
              'เบอร์โทรศัพท์': element.healthTel,
              'เลขที่รับแจ้ง': element.healthNumber,
              'วันที่เริ่มใช้สิทธิ์': element.healthStartDate,
              'วันที่หมดอายุ': element.healthExpireDate
            }
            tempHealth.push(s)
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      var Health = XLSX.utils.json_to_sheet(tempHealth)
      XLSX.utils.book_append_sheet(wb, Health, 'Health')
      var month = this.getMonthTh()
      let date = new Date()
      var year = moment().format('YYYY')
      var day = date.getDate()

      XLSX.writeFile(wb, 'ช้อมูลพนักงาน ' + dt.empCode + ' (' + day + ' ' + month + ' ' + year + ').xls') // name of the file is 'book.xlsx'
    },
    async saerchDataAdvanced () {
      var search = ''
      var check = false
      // config วันที่สร้าง วันที่แก้ไข
      // config นำวันที่สิ้นสุดมาต่อ 23:59:59
      if (
        this.search.create_date_start !== '' &&
        this.search.create_date_end === ''
      ) {
        this.search.create_date_end =
          this.search.create_date_start + ' 23:59:59'
      } else {
        if (this.search.create_date_start !== '') {
          this.search.create_date_end =
            this.search.create_date_end + ' 23:59:59'
        }
      }

      if (
        this.search.last_date_start !== '' &&
        this.search.last_date_end === ''
      ) {
        this.search.last_date_end = this.search.last_date_start + ' 23:59:59'
      } else {
        if (this.search.last_date_end !== '') {
          this.search.last_date_end = this.search.last_date_end + ' 23:59:59'
        }
      }
      for (var key in this.search) {
        check = true
        if (this.search[key]) {
          if (search !== '') {
            search += '&'
          }
          search += key + '=' + this.search[key]
        }

        if (
          this.search.last_date_start === '' &&
          this.search.last_date_end !== ''
        ) {
          check = false
          this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่แก้ไข เริ่มต้น', 'error')
        }

        if (
          this.search.create_date_start === '' &&
          this.search.create_date_end !== ''
        ) {
          check = false
          this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่สร้าง เริ่มต้น', 'error')
        }
      }
      //
      //
      // สำหรับ ค้นหาแบบ กำหนดจาก form serach
      //
      if (check === true) {
        this.dataReady = false

        this.saerchDataAdvancedGlobal(this.DNS_IP, this.path, search)
      } else {
        this.dataReady = true
      }
    },
    async deleteData (item) {
      console.log('DELETE PK : ', item.empId)
      console.log('DELETE PK : ', this.$session.getAll().data.userName)

      let ds = {
        LAST_USER: this.$session.getAll().data.userName
      }
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "delete/" + item.empId,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              // console.log('DNS_IP + PATH + "delete/"', response)

              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog
              this.dialogDelete = false

              // Load Data
              await this.getDataGlobal(this.DNS_IP, this.path)
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    // * Option Import Excel
    // * ตั้งค่าจาก Data
    importData (event) {
      var input = event.target
      var reader = new FileReader()
      reader.onload = () => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach((sheetName) => {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
          this.dataItemImport = rowObj
        })
        if (this.dataItemImport.length === 0) {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง')
        } else {
          this.dataItemImportChecKHide = false
        }
      }

      reader.readAsBinaryString(input.files[0])
    },
    importDataApprove (action) {
      var titleMsg = ''
      var checkError = false
      if (action === 'add') {
        titleMsg = 'ท่านต้องการ นำเข้าข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      } else if (action === 'delete') {
        titleMsg = 'ท่านต้องการ ลบข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      } else {
        titleMsg = 'ท่านต้องการ ปรับปรุงข้อมูลจากไฟล์นี้ ใช่หรือไม่'
      }

      this.$swal({
        title: titleMsg,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          for (var key in this.dataItemImport) {
            this.PK = this.dataItemImport[key].empId
            if (action === 'add') {
              await this.importDataAdd(this.dataItemImport[key])
              checkError = true
            } else {
              await axios
                .get(
                  // eslint-disable-next-line quotes
                  this.DNS_IP +
                    this.path +
                    'get?empId=' +
                    this.dataItemImport[key].empId,
                  {
                    headers: {
                      'Application-Key': this.$session.getAll().ApplicationKey
                    }
                  }

                )
                .then(async (response) => {
                  if (action === 'update') {
                    await this.importDataUpdate(this.dataItemImport[key])
                    checkError = true
                  }
                  if (action === 'delete') {
                    await this.importDataDelete(this.dataItemImport[key])
                    checkError = true
                  }
                })
                // eslint-disable-next-line handle-callback-err
                .catch((error) => {
                  checkError = false

                  console.log('error /master_title/get?empId : ', error)
                })
            }
          }
          console.log(checkError)
          if (checkError === true) {
            await this.getDataGlobal(this.DNS_IP, this.path)
          } else {
            this.dataItemImport = []
            this.dataItemImportChecKHide = true
            alert('โปรดใส่ไฟล์ให้ถูกต้อง')
          }
        })
        .catch((error) => {
          console.log('error function importDataApprove : ', error)
          this.dataReady = true
        })
    },
    async importDataAdd (dt) {
      // Object.assign(this.formAdd, dt)
      dt.CREATE_USER = this.$session.getAll().data.userName
      dt.LAST_USER = this.$session.getAll().data.userName

      delete dt['empId']
      delete dt['LAST_DATE']
      delete dt['CREATE_DATE']
      delete dt['RECORD_STATUS']
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "add",
          dt,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dialogImport = false
          // Debug response
          console.log('/master_title/add/', response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง', dt)
          console.log('error function importDataAdd addData : ', error)
          this.dataReady = true
        })
    },
    async importDataUpdate (dt) {
      Object.assign(this.formUpdate, dt)
      delete this.formUpdate['empId']
      delete this.formUpdate['LAST_DATE']
      delete this.formUpdate['CREATE_DATE']
      delete this.formUpdate['RECORD_STATUS']
      this.formUpdate.LAST_USER = this.$session.getAll().data.userName

      for (var key in this.formUpdateItem) {
        for (var key2 in this.formUpdate) {
          if (key === key2) {
            this.formUpdateItem[key] = this.formUpdate[key2]
          }
        }
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "edit/" + dt.empId,
          this.formUpdateItem,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }

        )
        .then(async (response) => {
          this.dialogImport = false
          // Debug response
          console.log('/master_title/edit/', response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง', dt)
          console.log('error function importDataUpdate : ', error)
        })
    },
    async importDataDelete (dt) {
      this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "delete/" + dt.empId,
          this.formUpdate
        )
        .then(async (response) => {
          this.dialogImport = false
          // Debug response
          console.log('/master_title/delete/', response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          alert('โปรดใส่ไฟล์ให้ถูกต้อง', dt)
          console.log('error function importDataDelete : ', error)
        })
    },
    exportData () {
      // this.dataItem = []
      // axios
      //   .get(
      //     // eslint-disable-next-line quotes
      //     this.DNS_IP + "/employee/get",
      //     {
      //       headers: {
      //         'Application-Key': this.$session.getAll().ApplicationKey
      //       }
      //     }
      //   )
      //   .then(async (response) => {
      // this.dataItem = response.data
      var tem = []
      this.dataItem.forEach(element => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'รหัสพนักงานเก่า': element.empCodeOld,
          'รหัสตำแหน่ง': element.positionCode,
          'lineuid': element.userLineuserId,
          'คำนำหน้าชื่อไทย': element.empTitle_NameTH,
          'ขื่อไทย': element.empFirst_NameTH,
          'นามสกุลไทย': element.empLast_NameTH,
          'ขื่อ-นามสกุลไทย': element.empFull_NameTH,
          'คำนำหน้าชื่ออังกฤษ': element.empTitle_NameEN,
          'ชื่อภาษาอังกฤษ': element.empFirst_NameEN,
          'นามสกุลอังกฤษ': element.empLast_NameEN,
          'ชื่อ-นามสกุลอังกฤษ': element.empFull_NameEN,
          'ชื่อเล่น': element.empNickname,
          'วันเกิด': element.empBirthday,
          'อายุ': element.AGE,
          'เพศ': element.empGender,
          'เบอร์ติดต่อ': element.empTel,
          'รหัสบัตรประชาชน': element.empIDCard,
          'Facebook': element.empFacebook,
          'LINE ID': element.empLineID,
          'เบอร์ฉุกเฉิน': element.empEmergencyCall,
          'เลขใบขับขี่': element.empDriverLicense,
          'ประเภทใบขับขี่': element.empDriverLicenseType,
          'งานอดิเรก': element.hobby,
          'วันทำบัตรประชาชน': element.issuedDate,
          'วันหมดอายุบัตรประชาชน': element.expireDate,
          'สถานที่ทำบัตรประชาชน': element.issuedAt,
          'จังหวัดที่ทำบัตรประชาชน': element.issuedProvince,
          'รับรองทางทหาร': element.masMilitaryStatusCode,
          'ตำแหน่งงาน': element.positionName,
          'ประเภทตำแหน่งงาน': element.positionTypeName,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ความสามารถพิเศษอื่นๆ': element.empGenius,
          'วันที่เริ่มทำงาน': element.startDate,
          'อายุงาน': element.workDate,
          'ปีที่ทำงาน': element.year_work_cal
        }
        tem.push(s)
      })
      console.log(tem)
      var info = XLSX.utils.json_to_sheet(tem)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
      var month = this.getMonthTh()
      let date = new Date()
      var year = moment().format('YYYY')
      var day = date.getDate()

      XLSX.writeFile(wb, 'ช้อมูลพนักงาน(' + day + ' ' + month + ' ' + year + ').xls') // name of the file is 'book.xlsx'
      // })
      // // eslint-disable-next-line handle-callback-err
      // .catch((error) => {
      //   console.log(error)
      // })
    },
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItemFilter?masBranchName=" + this.$session.getAll().data.masBranchName,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
<style>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeManageGA.vue